import { pick } from 'lodash'
import intl from 'react-intl-universal'

export default [
  '$rootScope',
  'contentTemplatesService',
  'storyService',
  'tabService',
  storyToolbar,
]

function storyToolbar(
  $rootScope,
  contentTemplatesService,
  storyService,
  tabService
) {
  this.intl = intl
  this.selectedFeature = {}
  this.selectedFeatureConfig = {}

  const setTabState = (tabId) => {
    this.isComposeTab = tabId === 'tab-compose'
  }

  this.convertiableContentElementTypeTranslations = {
    text: intl.get('ActionsToolbar.blockTypeDropdown.p'),
    header: intl.get('ActionsToolbar.blockTypeDropdown.h'),
    blockquote: intl.get('toolbox.elements.legacyBlockquote'),
  }

  this.$onInit = () => {
    this.convertableContentElements = contentTemplatesService.getConvertableTemplates()
    console.log({ convertableContentElements: this.convertableContentElements })
    setTabState(tabService.getActiveTabId())
  }

  $rootScope.$on('CHANGE_TAB', (sender, action) => {
    setTabState(action.tab.id)
  })

  $rootScope.$on('ELEMENT_FOCUS_CHANGE', (sender, action) => {
    if (action.feature) {
      this.selectedIndex = action.index
      this.selectedFeature = action.feature
      const featureConfig = contentTemplatesService.get(action.feature.type)
      this.selectedFeatureConfig = featureConfig
      this.isConvertableContentElement = this.convertableContentElements.some(
        (o) => o.type === this.selectedFeature.type
      )
      this.hasProperties = contentTemplatesService.getProperties(
        action.feature.type
      )
      this.hasPreview =
        contentTemplatesService.getPreview(action.feature.type) !== undefined
    } else {
      this.selectedIndex = -1
      this.selectedFeature = {}
      this.selectedFeatureConfig = {}
      this.isConvertableContentElement = false
    }
  })

  // obj: contentElementAction // TODO spec type
  const triggerAction = (obj) => {
    $rootScope.$broadcast('UPDATE_CONTENT_ELEMENT', obj)
  }

  /* LEFT MENU BAR ACTIONS */
  this.convertElementTo = (newElementType) => {
    if (this.selectedFeature) {
      const feature = Object.assign(
        {},
        newElementType.initialInflation(),
        pick(this.selectedFeature, ['additional_properties', '_id']),
        { content: this.selectedFeature.content }
      )

      this.selectedFeatureConfig = contentTemplatesService.get(feature.type)
      triggerAction({ action: 'convert', index: this.selectedIndex, feature })
    }
  }

  this.commentClick = (e) => {
    $rootScope.$broadcast('CONTENT_COMMENT', {
      type: 'OPEN_COMMENT',
      index: this.selectedIndex,
      elements: storyService.getStorySync().content_elements,
    })
  }

  /* RIGHT MENU BAR ACTIONS */
  this.btnAction = (event, action) => {
    event.preventDefault()
    event.stopPropagation()
    triggerAction({
      action,
      index: this.selectedIndex,
      feature: this.selectedFeature,
    })

    storyService.isDirty(true)
  }

  this.sendEvent = (evt, name) => {
    $rootScope.$broadcast('DISPATCH', {
      type: 'HANDLE_COMMANDS',
      sub_type: name,
      feature: this.selectedFeature,
      index: this.selectedIndex,
    })
    evt.preventDefault()
    evt.stopPropagation()
  }
}
